import { Box, Heading, Text, VStack, HStack, Icon } from '@chakra-ui/react';
import { WhatsappFloatingBall } from '../../../../packages/ui/components/atoms/WhatsappFloatingBall';
import { ContactForm } from '../../../../packages/ui/forms/ContactForm';
import { MainTemplate } from '../templates/MainTemplate';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';

export function ContactPage() {
  return (
    <MainTemplate hideBottomMenu>
      <WhatsappFloatingBall />
      <VStack align={'flex-start'} width={'90%'} maxW={'600px'} paddingTop={'50px'} spacing={8}>
        <Heading paddingBottom={'10px'}>Contato</Heading>
        
        {/* Informações de Contato */}
        <Box 
          width={'100%'} 
          p={4} 
          bg={'gray.50'} 
          borderRadius={'md'} 
          border={'1px solid'} 
          borderColor={'gray.200'}
        >
          <Heading size={'sm'} mb={3} color={'gray.700'} fontWeight={'600'}>
            Entre em Contato
          </Heading>
          
          <VStack spacing={2} align={'flex-start'}>
            <HStack spacing={2}>
              <Icon as={MdEmail} color={'blue.500'} boxSize={4} />
              <Text fontSize={'sm'} color={'gray.600'}>
                ajuda@partiu.com.br
              </Text>
            </HStack>
            
            <HStack spacing={2}>
              <Icon as={MdPhone} color={'green.500'} boxSize={4} />
              <Text fontSize={'sm'} color={'gray.600'}>
                +55 (21) 97420-4416
              </Text>
            </HStack>
          </VStack>
        </Box>
        
        <ContactForm />
      </VStack>
    </MainTemplate>
  );
}
